/**
 * This function contains all the functions to create, access, and remove cookies.
 */

/**
 * Sets a cookie with a specific lifetime.
 *
 * @param {string} name  - The name of the cookie.
 * @param {string} value - The value of the cookie.
 * @param {number} days  - The number of days until the cookie expires.
 */
export const setCookie = ( name, value, domain, days = 999 ) => {

	let expires = '';
	let newValue = value;

	if ( 'object' === typeof value || Array.isArray( value ) ) {
		newValue = JSON.stringify( value );
	}
	if ( days ) {
		const date = new Date();
		date.setTime( date.getTime() + days * 24 * 60 * 60 * 1000 );
		expires = '; expires=' + date.toUTCString();
	}

	const cookieString = `${name}=${newValue || ''}${expires}; path=/; domain=${
		domain
	}; SameSite=None; Secure`;
	document.cookie = cookieString;
};

/**
 * Gets a cookie by name.
 *
 * @param {string} name - The name of the cookie to retrieve.
 * @return {string|null} The value of the cookie, or null if not found.
 */
export const getCookie = ( name ) => {
	const nameEQ = name + '=';
	const ca = document.cookie.split( ';' );
	for ( let i = 0; i < ca.length; i++ ) {
		let c = ca[i];
		while ( ' ' === c.charAt( 0 ) ) {
			c = c.substring( 1, c.length );
		}
		if ( 0 === c.indexOf( nameEQ ) ) {
			return c.substring( nameEQ.length, c.length );
		}
	}
	return null;
};

/**
 * Removes a cookie by name.
 *
 * @param {string} name   - The name of the cookie to remove.
 * @param {string} domain - The domain for the cookie.
 */
export const removeCookie = ( name, domain ) => {
	document.cookie = `${name}=; Max-Age=-99999999; path=/; domain=${domain}; SameSite=None; Secure`;
};
